var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"depressed":"","color":_vm.color,"link":""},on:{"click":_vm.navigateBack}},[_vm._v(" Wróć "),(!_vm.enteredFromApp)?_c('span',{staticClass:"ml-1"},[_vm._v(" do listy projektów")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }